import * as Yup from 'yup'

export const typeBuildingSchema = Yup.object().shape({
  // Id: Yup.string().required(),
  CompaniaId: Yup.string().required('Compañía es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  CampamentoId: Yup.string().required('Campamento es requerido'),
  TipoModuloId: Yup.string().required('Tipo de módulo es requerido'),
  Codigo: Yup.string().required('Nomenclatura es requerida'),
  // TipoPreAsignacionId: Yup.string().required('Preasignación es requerido'),
  SexoId: Yup.string().required('Sexo es requerido'),
  TipoBanioId: Yup.string().required('Tipo de Baño es requerido'),
  NroPisos: Yup.number()
    .typeError('Nro de Pisos es requerido')
    .required('Nro de Pisos es requerido'),
  // NivelId: Yup.string().required('Nivel es requerido'),
  NroHabitaciones: Yup.number()
    .typeError('Nro de Habitaciones es requerido')
    .required('Nro de Habitaciones debe ser requerido'),
  PrioridadAsignacion: Yup.number()
    .typeError('Nro de secuencia de asignación es requerido')
    .required('Nro de secuencia de asignacion es requerido'),
  EstadoModuloId: Yup.string().required('Estado es requerido'),
  TipoEdificacionId: Yup.string().required('Tipo de Edificación es requerido'),
})